import type { JSONContent } from "@tiptap/core";
import { parseSparxMarkdownAst } from "@/lib/markdown/sparxMarkdownHtml";
import { blockNodeToTiptap } from "./markdownToTiptapBlocks";

export type MarkdownToTiptapDocOptions = {
  /** When false (compact RTE), omit horizontal rules — schema may not include horizontalRule. */
  emitHorizontalRules: boolean;
};

/**
 * Build TipTap document JSON from Sparxs markdown without HTML parsing.
 * Matches {@link parseSparxMarkdownAst} so thematic breaks and setext-style `---` underlines
 * become explicit `horizontalRule` nodes (preview parity with ReactMarkdown).
 */
export const markdownToTiptapDocJSON = (
  md: string,
  options: MarkdownToTiptapDocOptions,
): JSONContent => {
  const { rootChildren, variableSegments } = parseSparxMarkdownAst(md);
  const blocks: JSONContent[] = [];
  for (const node of rootChildren) {
    blocks.push(
      ...blockNodeToTiptap(node, variableSegments, options.emitHorizontalRules),
    );
  }
  if (blocks.length === 0) {
    return { type: "doc", content: [{ type: "paragraph" }] };
  }
  return { type: "doc", content: blocks };
};
